import type { Variant } from "features/daily-delivery/types";
import type { PropsWithChildren } from "react";
import { Card } from "./styled";

interface CardProps {
  variant: Variant;
  clickable?: boolean;
  onClick?: () => void;
}

export const MainCard = (props: PropsWithChildren<CardProps>) => {
  const { variant, children, clickable = false, onClick } = props;
  return (
    <Card variant={variant} clickable={clickable} onClick={onClick}>
      {children}
    </Card>
  );
};